import { Settings } from 'luxon'

// Configure Luxon globally for Australian locale
Settings.defaultLocale = 'en-AU'
Settings.defaultZone = 'Australia/Melbourne'
Settings.defaultWeekSettings = {
  firstDay: 7, // Sunday (7 = Sunday in Luxon)
  minimalDays: 1, // Week 1 is any week containing Jan 1st
  weekend: [6, 7] // Saturday and Sunday (6 = Saturday, 7 = Sunday)
}
